import type { IntlError } from 'next-intl';

/**
 * Custom fallback handler for next-intl translation errors.
 *
 * For INSUFFICIENT_PATH (key resolves to an object), we return the key path so
 * the UI shows e.g. "nav.utility.account" rather than "nav.utility.account._self".
 * Prefer using translateWithSelfFallback(t, key) at call sites so the correct
 * string from _self is shown.
 */
export function getMessageFallback({
  error,
  key,
}: {
  error: IntlError;
  key: string;
  namespace?: string;
}): string {
  if (error.code === 'INSUFFICIENT_PATH') {
    return key;
  }

  return key;
}
